<ng-container *clientScreen="let isDesktop = isDesktop">
	<pre>{{ opened }}</pre>
	@if (opened) {
		<div
			moveToRoot
			class="backdrop pt-safe-t pr-safe-r pb-safe-b pl-safe-l top-0 left-0 w-full h-full fixed box-border backdrop-menu"
			(click)="outsideClick()"
		>
			<div class="w-full h-full flex items-center justify-center whitespace-pre-line">
				<div
					class="modal-panel bg-180 shadow-z-menu flex flex-col items-center justify-start scrollbar-fade overflow-auto"
					[class.desktop]="isDesktop"
					[class.full-size]="fullSize"
					[class.mobile]="!isDesktop"
					(click)="$event.stopPropagation()"
				>
					<div class="px-1 flex-none w-full h-2 flex items-center justify-end">
						<ng-content select="title"></ng-content>
						<div class="flex justify-end flex-1">
							@if (showClose) {
								<button
									uiNewButtonIcon
									size="SMALL"
									[ngStyle]="{ color: 'var(--color-text-400)' }"
									(click)="close()"
								>
									<i class="icon-cross"></i>
								</button>
							}
						</div>
					</div>
					<div class="flex-auto w-full scrollbar-fade overflow-auto">
						<ng-content></ng-content>
					</div>
					<ng-content select="description"></ng-content>
				</div>
			</div>
		</div>
	}
</ng-container>
